import { fetchPost } from '__utils/ajax-wrapper';

export const signzyChequeImgToUrl: any = async (endpoint: string, chequeUrl: any) => {
    const res = await fetch(chequeUrl)
        .then(async (response: any) =>
            ({ blob: await response.blob(), fileType: response.headers.get('content-type') ?? 'image/png' }))
        .then(fileData => {
            var file = new File([ fileData.blob ], "cheque.jpg", { type: fileData.fileType });
            console.log("bank");
            return file;
        })
    console.log(res, res.size);
    if (res.size < 5000000)
    {
        const formData = new FormData();
        res && formData.append('file', res);
        const fetchRes = await fetchPost(
            endpoint, formData, null, true
        ).then((response: any) => {
            if (response?.data?.cancelledChequeURL)
            {
                return response?.data?.cancelledChequeURL;
            }
        }).catch((error: any) => {
            console.log("Can not upload file now. Please try later.");
        })
        return (fetchRes);
    }
    else return('');
}
export const signzyImgToUrl: any = async (endpoint: string, signUrl: any) => {
    const signBlob = await fetch(signUrl)
        .then(async (response: any) =>
            ({ blob: await response.blob(), fileType: response.headers.get('content-type') ?? 'image/png' }))
        .then(fileData => {
            var file = new File([ fileData.blob ], "sign.jpg", { type: fileData.fileType });
            console.log("sign");
            return file;
        })
    if (signBlob.size < 5000000)
    {
        const formData = new FormData();
        signBlob && formData.append('file', signBlob);
        const fetchRes = await fetchPost(
            endpoint, formData, null, true
        ).then((response: any) => {
            if (response?.value)
            {
                return response?.value;
            }
        }).catch((error: any) => {
            console.log("Can not upload file now. Please try later.");
        })
        return (fetchRes);
    }
    else return ('');

}
